class RecaptchaHelper {

    constructor() {
        this.executed = false
    }

    /**
     * @param $el
     */
    setInputElement($el) {
        this.inputElement = $el
    }

    /**
     * Call execute to start up recaptcha, call the script if necessary and run
     * whatever code you provide.
     *
     * @param done Success callback
     * @param fail Failure callback
     * @returns {RecaptchaClass}
     */
    execute(done, fail) {
        if (typeof window.grecaptcha === 'undefined' || !document.querySelector('#g-recaptcha-challenge').querySelector('.g-recaptcha-response')) {

            this.executed = false
            // Async recaptcha loading callback
            window.onRecaptchaLoadCallback = () => {
                this.execute(done, fail)
            }

            this.getScript('https://www.google.com/recaptcha/api.js?hl=en&onload=onRecaptchaLoadCallback', () => {
            })

            return this
        }

        window.submitRecaptchaForm = (response) => {
            return new Promise((resolve, reject) => {
                this.executed = true
                if (this.inputElement) {
                    const element = document
                        .querySelector('#g-recaptcha-challenge')
                        .querySelector('.g-recaptcha-response')
                    this.inputElement.value = element.value
                }
                done()
                resolve()
            })
        }

        window.failedRecaptchaForm = () => {
            this.executed = false
            fail()
        }

        if (this.executed) {
            if (this.inputElement) {
                this.inputElement.value = ''
            }
            window.grecaptcha.reset()
        }

        window.grecaptcha.execute()

        return this
    }

    /**
     * @param src
     * @param cb
     */
    getScript (src, cb) {
        let script = document.createElement('script')
        let prior = document.getElementsByTagName('script')[0]
        // script.async = 1

        script.onload = script.onreadystatechange = function( _, isAbort ) {
            if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
                script.onload = script.onreadystatechange = null
                script = undefined
                if(!isAbort && cb) setTimeout(cb, 0)
            }
        }

        script.src = src
        prior.parentNode.insertBefore(script, prior)
    }
}

const Recaptcha = new RecaptchaHelper()

export { Recaptcha }
